import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "left"
          }}>{`Set`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Range`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Latin`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+0000-00FF`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Latin Extended-A`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+0100-017F`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Latin Extended-B`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+0180-024F`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Latin Extended Additional`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+1E00-1EFF`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "left"
          }}>{`Rest`}</td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`U+2000-FB01`}</inlineCode></td>
</tr>
</tbody>
</table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      